"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-lines-per-function */
/** @jsx jsx */
const core_1 = require("@emotion/core");
const lodash_1 = require("lodash");
const react_1 = require("react");
const react_device_detect_1 = require("react-device-detect");
const react_player_1 = __importDefault(require("react-player"));
const screenfull_1 = __importDefault(require("screenfull"));
const constants_1 = require("@/constants");
const styled_react_1 = __importDefault(require("./styled-react"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const VideoPlayer = react_1.forwardRef((_a, ref) => {
    var { id, title, onPlay, onPause, onEnded, onProgress, onDuration, url } = _a, rest = __rest(_a, ["id", "title", "onPlay", "onPause", "onEnded", "onProgress", "onDuration", "url"]);
    const [isPlaying, setIsPlaying] = react_1.useState(false);
    const [isFullScreen, setIsFullScreen] = react_1.useState(false);
    const [isOverlayOpen, setIsOverlayOpen] = react_1.useState(false);
    const overlayRef = react_1.useRef(null);
    const overlayNode = overlayRef.current;
    const containerRef = react_1.useRef(null);
    const fullScreenChanged = () => {
        // @ts-ignore
        if (document.webkitIsFullScreen === false) {
            setIsFullScreen(false);
            // @ts-ignore
        }
        else if (document.mozFullScreen === false) {
            setIsFullScreen(false);
            // @ts-ignore
        }
        else if (document.msFullscreenElement === false) {
            setIsFullScreen(false);
        }
    };
    react_1.useEffect(() => {
        document.addEventListener('fullscreenchange', fullScreenChanged, false);
        return () => {
            document.removeEventListener('fullscreenchange', null, false);
        };
    }, []);
    if (overlayNode) {
        if (!react_device_detect_1.isMobile) {
            let mouseMoveTimeout;
            overlayNode.addEventListener('mousemove', () => {
                clearTimeout(mouseMoveTimeout);
                setIsOverlayOpen(true);
                mouseMoveTimeout = setTimeout(() => {
                    setIsOverlayOpen(false);
                }, 3000);
            });
        }
        overlayNode.addEventListener('mouseleave', () => {
            setIsOverlayOpen(false);
        });
        overlayNode.addEventListener('touchstart', () => {
            setIsOverlayOpen(true);
        });
        overlayNode.addEventListener('touchend', () => {
            setTimeout(() => {
                setIsOverlayOpen(false);
            }, 2000);
        });
    }
    const player = ref;
    const handleClickFullscreen = () => {
        const bottomBar = document.getElementById('bottomBarContainer');
        setIsFullScreen(prev => {
            if (screenfull_1.default.isEnabled) {
                if (prev) {
                    screenfull_1.default.exit();
                    bottomBar.style.display = 'block';
                }
                else {
                    screenfull_1.default.request(containerRef.current.wrapper);
                    bottomBar.style.display = 'none';
                }
            }
            return !prev;
        });
    };
    react_1.useEffect(() => {
        if (!lodash_1.isEmpty(player.current)) {
            // hacky solution
            setTimeout(() => {
                player.current.seekTo(0);
            }, 100);
        }
    }, [id]);
    return (core_1.jsx("div", { css: styled_react_1.default.videoWrapper(isFullScreen), className: styles_scss_1.default.videoPlayerContainer, ref: containerRef },
        core_1.jsx(react_player_1.default, Object.assign({ ref: player, className: styles_scss_1.default.video, width: "100%", height: "auto", url: url, controls: false, playsinline: true, playing: isPlaying, onDuration: duration => {
                if (onDuration) {
                    onDuration(duration);
                }
            }, onPlay: () => {
                setIsPlaying(true);
                if (onPlay) {
                    onPlay();
                }
            }, onPause: () => {
                setIsPlaying(false);
                if (onPause) {
                    onPause();
                }
            }, onEnded: () => {
                player.current.seekTo(0);
                if (onEnded) {
                    onEnded();
                }
                if (screenfull_1.default.isEnabled) {
                    screenfull_1.default.exit();
                }
            }, onProgress: state => {
                if (onProgress) {
                    onProgress(state);
                }
            } }, rest)),
        core_1.jsx("div", { className: styles_scss_1.default.overlay, css: styled_react_1.default.overlay(isOverlayOpen || !isPlaying), ref: overlayRef },
            core_1.jsx("div", { className: styles_scss_1.default.expanderCont },
                core_1.jsx("button", { className: styles_scss_1.default.expanderBtn, css: styled_react_1.default.expanderBtn(constants_1.Images.maximize), type: "button", onClick: handleClickFullscreen })),
            core_1.jsx("div", { className: styles_scss_1.default.controlsCont, css: styled_react_1.default.controlsCont(isFullScreen) },
                core_1.jsx("div", { className: styles_scss_1.default.controlsLeftCont },
                    core_1.jsx("button", { className: styles_scss_1.default.playPauseBtn, css: styled_react_1.default.playPauseBtn(isPlaying ? constants_1.Images.pauseFilled : constants_1.Images.playFilled), type: "button", onClick: () => setIsPlaying((prevState) => !prevState) })),
                core_1.jsx("div", { className: styles_scss_1.default.controlsCenterCont },
                    core_1.jsx("h4", null, title)),
                core_1.jsx("div", { className: styles_scss_1.default.controlsRightCont })))));
});
exports.default = VideoPlayer;
